import {
  AlertTriangle,
  CheckCircle2,
  MinusCircle,
  PlusCircle,
} from "lucide-react";

import { cn } from "@/lib/utils";

interface Props {
  matchCount: number;
  totalItems: number;
  minusCount: number;
  plusCount: number;
  netDiffValue: number;
}

export function StockOpnameMetricsBar({
  matchCount,
  totalItems,
  minusCount,
  plusCount,
  netDiffValue,
}: Props) {
  const roundedDiff = Math.round(netDiffValue);
  const isNegative = roundedDiff < 0;
  const isPositive = roundedDiff > 0;
  const absRounded = Math.abs(roundedDiff === 0 ? 0 : roundedDiff);

  return (
    <div className="grid grid-cols-2 gap-2 border-b bg-muted/30 px-3 sm:px-6 py-2 sm:py-3 sm:grid-cols-4">
      <div className="rounded-lg border bg-background p-2.5 shadow-xs">
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <CheckCircle2 className="h-3.5 w-3.5 text-emerald-500" />
          <span>Stok Cocok</span>
        </div>
        <p className="mt-1 text-lg font-bold text-foreground">
          {matchCount}{" "}
          <span className="text-xs font-normal text-muted-foreground">
            / {totalItems} item
          </span>
        </p>
      </div>

      <div className="rounded-lg border bg-background p-2.5 shadow-xs">
        <div className="flex items-center gap-1.5 text-xs text-destructive">
          <MinusCircle className="h-3.5 w-3.5" />
          <span>Selisih Kurang</span>
        </div>
        <p className="mt-1 text-lg font-bold text-destructive">
          {minusCount}{" "}
          <span className="text-xs font-normal text-muted-foreground">
            item
          </span>
        </p>
      </div>

      <div className="rounded-lg border bg-background p-2.5 shadow-xs">
        <div className="flex items-center gap-1.5 text-xs text-blue-600 dark:text-blue-400">
          <PlusCircle className="h-3.5 w-3.5" />
          <span>Selisih Lebih</span>
        </div>
        <p className="mt-1 text-lg font-bold text-blue-600 dark:text-blue-400">
          {plusCount}{" "}
          <span className="text-xs font-normal text-muted-foreground">
            item
          </span>
        </p>
      </div>

      <div className="rounded-lg border bg-background p-2.5 shadow-xs">
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <AlertTriangle className="h-3.5 w-3.5 text-amber-500" />
          <span>Dampak Nilai</span>
        </div>
        <p
          className={cn(
            "mt-1 text-lg font-bold",
            isNegative
              ? "text-destructive"
              : isPositive
                ? "text-emerald-600"
                : "text-foreground",
          )}
        >
          {isNegative ? "-Rp " : "Rp "}
          {absRounded.toLocaleString("id-ID")}
        </p>
      </div>
    </div>
  );
}
